import { FC } from 'react'

type Props = {
  descripcion?: string
}

const LogCeldaDescripcion: FC<Props> = ({ descripcion }) => (
  <div className=' fw-bolder'>{descripcion}</div>
)

export { LogCeldaDescripcion }
